export default {
  DeliveryUpdate: "1344f9bc-8919-4a4a-ad23-79e73828b129",
  RefillRequest: "b09ce90d-c022-4555-bdf8-1f2e2146bf8b",
  AppointmentRequest: "36bacb5e-c78b-4f7b-9276-a9b32c81849d",
  NewPatientEnrollment: "36bacb5e-c78b-4f7b-9276-a9b32c81849d",
  MonitorLiveAgents: "caf4b41a-d281-43b6-9cc8-13e5a499e173",
  MissedConsultationCall: "bc3571b8-9b76-4239-a949-a1c57b54e14f",
};



// WEBPACK FOOTER //
// ./src/components/taskmanager/taskTypeEnum.js